module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/indi-store/opening-times/store-opening-times.component.css
// module id = ./src/app/indi-store/opening-times/store-opening-times.component.css
// module chunks = main